module.exports = __webpack_public_path__ + "img/14.27f38eed.png";